/**
 * PostEmitter — 게시글 열기 이벤트 중개
 *
 * 채팅의 AutoMessage 카드 "post-created" 클릭 시 RoomPage가 듣고
 * 해당 게시판 + 게시글을 분할 뷰로 자동 표시.
 *
 * TaskEmitter / WikiPageEmitter 패턴과 동일.
 */
import EventEmitter from 'eventemitter3';

export const PostEmitter = new EventEmitter();

/**
 * 이벤트 시그니처:
 * - 'open' (roomId: string, boardId: string, postId: string)
 *   → 시스템 메시지/외부에서 특정 게시글 열기.
 */
